import { User } from '../entities';
import { Global } from '../../utils/global';

export class SessionService {
  static saveSession(user: User) {
    const userObject = JSON.stringify(user);
    window.localStorage.setItem(Global.LOCAL_STORAGE_USER_FIELD, userObject);
  }

  static deleteSession() {
    window.localStorage.removeItem(Global.LOCAL_STORAGE_USER_FIELD);
  }

  static getSession(): User {
    const user = window.localStorage.getItem(Global.LOCAL_STORAGE_USER_FIELD);
    if (!user) throw new Error('User not found');
    return JSON.parse(user);
  }

  static isAuthenticated(): boolean {
    try {
      return this.getSession() !== null;
    } catch (e) {
      return false;
    }
  }
}
